import { ref } from 'vue';
function useCursor(input) {
  const selectionRef = ref();
  function recordCursor() {
    if (input.value == void 0) return;
    const _input$value = input.value,
      selectionStart = _input$value.selectionStart,
      selectionEnd = _input$value.selectionEnd,
      value = _input$value.value;
    if (selectionStart == null || selectionEnd == null) return;
    const beforeTxt = value.slice(0, Math.max(0, selectionStart));
    const afterTxt = value.slice(Math.max(0, selectionEnd));
    selectionRef.value = {
      selectionStart,
      selectionEnd,
      value,
      beforeTxt,
      afterTxt
    };
  }
  function setCursor() {
    if (input.value == void 0 || selectionRef.value == void 0) return;
    const value = input.value.value;
    const _selectionRef$value = selectionRef.value,
      beforeTxt = _selectionRef$value.beforeTxt,
      afterTxt = _selectionRef$value.afterTxt,
      selectionStart = _selectionRef$value.selectionStart;
    if (beforeTxt == void 0 || afterTxt == void 0 || selectionStart == void 0) return;
    let startPos = value.length;
    if (value.endsWith(afterTxt)) {
      startPos = value.length - afterTxt.length;
    } else if (value.startsWith(beforeTxt)) {
      startPos = beforeTxt.length;
    } else {
      const beforeLastChar = beforeTxt[selectionStart - 1];
      const newIndex = value.indexOf(beforeLastChar, selectionStart - 1);
      if (newIndex !== -1) {
        startPos = newIndex + 1;
      }
    }
    input.value.setSelectionRange(startPos, startPos);
  }
  return [recordCursor, setCursor];
}
export { useCursor };